<template>
  <!-- Header -->
  <div class="header">
    <div class="h-screen text-center">
      <h1 class="not-found text-muted">403!</h1>
      <p class="display-2 text-light">
        No tienes permiso para acceder a este recurso
      </p>
      <router-link to="/" class="font-weight-bold text-warning mt-5">Volver a inicio</router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'NotFound',
};
</script>
<style lang="scss" scoped>
.not-found {
  font-size: 10rem;
}
</style>
